class LuxurySelect {
    constructor(realSelect) {
        this.realSelect = realSelect;
        this.options = Array.from(realSelect.options);
        this.wrapper = null;
        this.trigger = null;
        this.list = null;
        this.items = [];
        this.active = -1;

        this.boundClose = this.close.bind(this);

        this.init();
    }

    init() {
        this.realSelect.style.display = 'none';

        this.wrapper = document.createElement('div');
        this.wrapper.className = 'luxury-select-wrapper';
        if (this.realSelect.id) this.wrapper.classList.add('select-' + this.realSelect.id);

        this.trigger = document.createElement('div');
        this.trigger.className = 'luxury-select-trigger';
        this.trigger.tabIndex = 0;
        this.trigger.setAttribute('role', 'combobox');
        this.trigger.setAttribute('aria-haspopup', 'listbox');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.trigger.innerHTML = `<span>${this.realSelect.options[this.realSelect.selectedIndex].text}</span><i class="arrow"></i>`;

        this.list = document.createElement('div');
        this.list.className = 'luxury-select-list';
        this.list.setAttribute('role', 'listbox');

        this.options.forEach((opt, index) => {
            const item = document.createElement('div');
            item.className = 'luxury-select-item';
            item.setAttribute('role', 'option');
            if (index === this.realSelect.selectedIndex) item.classList.add('is-selected');
            item.innerText = opt.text;
            item.dataset.value = opt.value;

            item.addEventListener('click', (e) => {
                e.preventDefault();
                this.selectItem(opt.value, opt.text, item);
            });
            this.list.appendChild(item);
            this.items.push(item);
        });

        this.wrapper.appendChild(this.trigger);
        this.wrapper.appendChild(this.list);
        this.realSelect.parentNode.insertBefore(this.wrapper, this.realSelect);

        this.trigger.addEventListener('click', (e) => {
            // preventDefault: select w <label> nie dostaje wtórnego kliknięcia, które zamykałoby listę
            e.preventDefault();
            e.stopPropagation();
            this.toggle();
        });

        this.trigger.addEventListener('keydown', (e) => this.onKey(e));

        document.addEventListener('click', this.boundClose);
    }

    onKey(e) {
        const open = this.wrapper.classList.contains('is-open');
        if (e.key === 'Escape') {
            this.close();
            return;
        }
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (open && this.active > -1) {
                const it = this.items[this.active];
                this.selectItem(it.dataset.value, it.textContent, it);
            } else {
                this.toggle();
            }
            return;
        }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            if (!open) { this.toggle(); return; }
            const step = e.key === 'ArrowDown' ? 1 : -1;
            this.setActive(Math.min(this.items.length - 1, Math.max(0, (this.active < 0 ? this.realSelect.selectedIndex : this.active) + step)));
        }
    }

    setActive(i) {
        this.active = i;
        this.items.forEach((it, idx) => it.classList.toggle('is-active', idx === i));
        this.items[i]?.scrollIntoView({ block: 'nearest' });
    }

    toggle() {
        document.querySelectorAll('.luxury-select-wrapper').forEach(el => {
            if (el !== this.wrapper) el.classList.remove('is-open');
        });
        const open = this.wrapper.classList.toggle('is-open');
        this.trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) this.setActive(Math.max(0, this.realSelect.selectedIndex));
    }

    close() {
        this.wrapper?.classList.remove('is-open');
        this.trigger?.setAttribute('aria-expanded', 'false');
        this.active = -1;
        this.items.forEach(it => it.classList.remove('is-active'));
    }

    selectItem(value, label, itemElement) {
        this.realSelect.value = value;
        this.trigger.querySelector('span').innerText = label;

        this.list.querySelectorAll('.luxury-select-item').forEach(i => i.classList.remove('is-selected'));
        itemElement.classList.add('is-selected');

        this.close();

        this.realSelect.dispatchEvent(new Event('change'));
    }

    destroy() {
        document.removeEventListener('click', this.boundClose);

        if (this.wrapper) {
            this.wrapper.remove();
            this.wrapper = null;
        }

        this.realSelect.style.display = '';
    }
}

export default LuxurySelect;
